import { SanityImageType } from "@silversea-ssc/ui-components-react"
import { SlideshowItem, InternalSlideshowItemProps, SlideshowItemImage } from "./Slideshow"

export function convertImages(items: SlideshowItem[], hideCaption: boolean): InternalSlideshowItemProps[] {
    return items
        .map((item) => {
            const galleryItem = convertImage(item as SlideshowItemImage, hideCaption)

            if (!galleryItem) return undefined

            const image: InternalSlideshowItemProps = {
                key: `slideshow-${item._key || item.asset._id}`,
                ...galleryItem,
            }

            return image
        })
        .filter((i): i is InternalSlideshowItemProps => !!i)
}

function convertImage(item: SlideshowItemImage, hideCaption: boolean): InternalSlideshowItemProps | undefined {
    if (!item.asset?._id) return undefined
    const caption = "caption" in item ? item.caption || " " : " "

    return {
        image: item as SanityImageType,
        isVideo: false,
        imageAlt: item.alt || caption,
        description: hideCaption ? undefined : caption,
    }
}

// function convertVideo(
//     item: VideoWithPosterImageFragment,
//     hideCaption: boolean,
// ): InternalSlideshowItemProps | undefined {
//     const image = item.posterImage
//     if (!image?.asset?._id) return undefined
//     const caption = "caption" in item ? item.caption?.localized || " " : " "

//     return {
//         image: image as SanityImageType,
//         isVideo: true,
//         video: {
//             file: item.file,
//             trackingTitle: item.trackingTitle,
//         },
//         description: hideCaption ? undefined : caption,
//     }
// }
